/**
* LoginWarningTxt.jsx
* Created by Destin Frasier 4/15/16
*/

const LoginWarningTxt = () => {
    return (
        <div className="usa-da-warning-msg container">
            <div className="row">
                <div className="col-md-12 warning-text">
                    <p>
                        <strong>WARNING WARNING WARNING</strong> You have accessed a U.S. Government information
                        system, which includes (1) this computer, (2) this network, (3) all computers connected to
                        this network, and (4) all devices and storage media attached to this network or to a
                        computer on this network. U.S. Government information systems are provided for the
                        processing of official U.S. Government information only. Unauthorized or improper use of
                        this information system is prohibited and may subject you to disciplinary action, as well
                        as civil and criminal penalties. All data contained on U.S. Government information systems
                        is owned by the U.S. Government and may, for the purpose of protecting the rights and
                        property of the U.S. Government, be monitored, intercepted, recorded, read, searched,
                        copied, or captured in any manner and disclosed or used for any lawful government purpose
                        at any time. THERE IS NO RIGHT TO PRIVACY IN THIS SYSTEM. System personnel may give to law
                        enforcement officials any potential evidence of crime found on U.S. Government information
                        systems. USE OF THIS SYSTEM BY ANY USER, AUTHORIZED OR UNAUTHORIZED, CONSTITUTES YOUR
                        UNDERSTANDING AND CONSENT TO THIS MONITORING, INTERCEPTION, RECORDING, READING, COPYING, OR
                        CAPTURING AND DISCLOSURE.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default LoginWarningTxt;
